/** Custom events for join-room UX (inline errors without kicking user off the form). */

export const JOIN_ROOM_ERROR_EVENT = 'toyo:join-room-error';

export function dispatchJoinRoomError(message: string): void {
  window.dispatchEvent(
    new CustomEvent(JOIN_ROOM_ERROR_EVENT, { detail: { message } })
  );
}

export function isJoinRoomNotFoundMessage(message?: string): boolean {
  if (!message) return false;
  const lower = message.toLowerCase();
  return (
    lower.includes('room not found') ||
    lower.includes('room destroyed') ||
    lower.includes('room was closed') ||
    lower.includes("room doesn't exist")
  );
}
